var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('ShowFiltersButton',{nativeOn:{"click":function($event){return _vm.showFilters.apply(null, arguments)}}}),_c('EnterButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }